'use client';

import ImageLightbox from '@/components/ui/ImageLightbox';
import LazyLiquidEther from '@/components/backgrounds/LazyLiquidEther';

// 5BHK Floor Plan Variants
const floorPlans5BHK = [
  {
    id: '5bhk-first-floor',
    title: '5 BHK - First Floor',
    subtitle: 'Block A - Units 101, 102',
    badge: 'PREMIUM',
    badgeColor: 'amber',
    totalArea: '~4,200 sq.ft.',
    carpetArea: '~3,150 sq.ft.',
    features: ['Private Terrace', 'Garden Access', 'Double Height Living'],
    technicalPlan: '/assets/floorPlan/5bhk-first-floor.png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/isometric_5BHK_BLOCK_A_101,102_FIRST_FLOOR.webp',
    highlights: [
      { label: 'Bedrooms', value: '5' },
      { label: 'Bathrooms', value: '6' },
      { label: 'Living Areas', value: '2' },
      { label: 'Kitchen', value: '1+1' },
    ],
    rooms: [
      { name: 'M. Bedroom 3', size: `20'0" x 12'0"` },
      { name: 'M. Bedroom 2', size: `20'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 20'3"` },
      { name: 'Bedroom 4', size: `18'0" x 12'0"` },
      { name: 'G. Bedroom 1', size: `14'0" x 12'0"` },
      { name: 'Drawing Room', size: `20'0" x 12'0"` },
      { name: 'Living', size: `20'0" x 12'0"` },
      { name: 'Dining', size: `20'0" x 11'0"` },
      { name: 'Kitchen', size: `14'0" x 16'0"` },
      { name: 'Wet Kitchen', size: `8'0" x 8'0"` },
      { name: 'Puja', size: `5'8" x 8'6"` },
      { name: 'Servant Room', size: `10'0" x 7'0"` },
      { name: 'Verandah', size: `8'0" x 47'3"` },
    ],
  },
  {
    id: '5bhk-even-type1',
    title: '5 BHK - Type A',
    subtitle: 'Block A - Units 201, 401, 601...2001',
    badge: 'EVEN FLOORS',
    badgeColor: 'blue',
    totalArea: '~4,000 sq.ft.',
    carpetArea: '~3,000 sq.ft.',
    features: ['Corner Unit', 'Cross Ventilation', 'City View'],
    technicalPlan: '/assets/floorPlan/5BHK_BLOCK_A_201,401,601-2001_2nd_4th_6th---EvenFLOORS_UPUNTIL_20th.png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/isometric_5BHK_BLOCK_A_201,401,601-2001_2nd_4th_6th---EvenFLOORS_UPUNTIL_20th.webp',
    highlights: [
      { label: 'Bedrooms', value: '5' },
      { label: 'Bathrooms', value: '6' },
      { label: 'Living Areas', value: '2' },
      { label: 'Kitchen', value: '1+1' },
    ],
    rooms: [
      { name: 'M. Bedroom 3', size: `20'0" x 12'0"` },
      { name: 'M. Bedroom 2', size: `20'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 20'3"` },
      { name: 'Bedroom 4', size: `18'0" x 12'0"` },
      { name: 'G. Bedroom 1', size: `14'0" x 12'0"` },
      { name: 'Drawing Room', size: `20'0" x 12'0"` },
      { name: 'Living', size: `20'0" x 12'0"` },
      { name: 'Dining', size: `20'0" x 11'0"` },
      { name: 'Kitchen', size: `14'0" x 16'0"` },
      { name: 'Wet Kitchen', size: `8'0" x 8'0"` },
      { name: 'Puja', size: `5'8" x 8'6"` },
      { name: 'Store', size: `6'1" x 9'4"` },
      { name: 'Servant Room', size: `10'0" x 7'0"` },
      { name: 'Verandah', size: `8'0" x 22'7"` },
    ],
  },
  {
    id: '5bhk-even-type2',
    title: '5 BHK - Type B',
    subtitle: 'Block A - Units 202, 402, 602...2002',
    badge: 'EVEN FLOORS',
    badgeColor: 'blue',
    totalArea: '~4,000 sq.ft.',
    carpetArea: '~3,000 sq.ft.',
    features: ['Mirror Layout', 'Cross Ventilation', 'Park View'],
    technicalPlan: '/assets/floorPlan/5BHK_BLOCK_A_202,402,602-2002_2nd_4th_6th-upuntill-20th_floor.png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/isometric_5BHK_BLOCK_A_202,402,602-2002_2nd_4th_6th-upuntill-20th_floor.webp',
    highlights: [
      { label: 'Bedrooms', value: '5' },
      { label: 'Bathrooms', value: '6' },
      { label: 'Living Areas', value: '2' },
      { label: 'Kitchen', value: '1+1' },
    ],
    rooms: [
      { name: 'M. Bedroom 3', size: `20'0" x 12'0"` },
      { name: 'M. Bedroom 2', size: `20'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 20'3"` },
      { name: 'Bedroom 4', size: `18'0" x 12'0"` },
      { name: 'G. Bedroom 1', size: `14'0" x 12'0"` },
      { name: 'Drawing Room', size: `20'0" x 12'0"` },
      { name: 'Living', size: `20'0" x 12'0"` },
      { name: 'Dining', size: `20'0" x 11'0"` },
      { name: 'Kitchen', size: `14'0" x 16'0"` },
      { name: 'Wet Kitchen', size: `8'0" x 8'0"` },
      { name: 'Puja', size: `5'8" x 8'6"` },
      { name: 'Store', size: `6'1" x 9'4"` },
      { name: 'Servant Room', size: `10'0" x 7'0"` },
      { name: 'Verandah', size: `8'0" x 25'10"` },
    ],
  },
];

// 4BHK Floor Plan Variants
const floorPlans4BHK = [
  {
    id: '4bhk-first-floor',
    title: '4 BHK - First Floor',
    subtitle: 'Block B - Units 101, 102',
    badge: 'PREMIUM',
    badgeColor: 'amber',
    totalArea: '~3,100 sq.ft.',
    carpetArea: '~2,325 sq.ft.',
    features: ['Private Terrace', 'Garden Access', 'Private Foyer'],
    technicalPlan: '/assets/floorPlan/4bhk-first-floor.png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/isometric_4BHK_BLOCK-B_101,102_FIRST_FLOOR.webp',
    highlights: [
      { label: 'Bedrooms', value: '4' },
      { label: 'Bathrooms', value: '5' },
      { label: 'Living Areas', value: '1' },
      { label: 'Kitchen', value: '1' },
    ],
    rooms: [
      { name: 'M. Bedroom 2', size: `19'3" x 12'0"` },
      { name: 'M. Bedroom 3', size: `15'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 18'0"` },
      { name: 'G. Bedroom 1', size: `12'0" x 14'0"` },
      { name: 'Drawing Room', size: `12'0" x 20'0"` },
      { name: 'Dining', size: `19'7" x 12'0"` },
      { name: 'Kitchen', size: `15'0" x 11'5"` },
      { name: 'Puja', size: `6'0" x 6'0"` },
      { name: 'Private Foyer', size: `11'0" x 15'0"` },
      { name: 'Servant Room', size: `10'0" x 7'2"` },
      { name: 'Verandah', size: `24'4" x 11'9"` },
    ],
  },
  {
    id: '4bhk-even-type1',
    title: '4 BHK - Type A',
    subtitle: 'Block B - Units 201, 204, 401, 404...2001, 2004',
    badge: 'EVEN FLOORS',
    badgeColor: 'blue',
    totalArea: '~2,900 sq.ft.',
    carpetArea: '~2,175 sq.ft.',
    features: ['Corner Unit', 'Panoramic View', 'Large Verandah'],
    technicalPlan: '/assets/floorPlan/4bhk_201,204,401,404,601--2001,604--2004_2nd_4th_6th_upuntil_20thfloor.png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/ISOMETRIC_4bhk_201,204,401,404,601--2001,604--2004_2nd_4th_6th_upuntil_20thfloor.webp',
    highlights: [
      { label: 'Bedrooms', value: '4' },
      { label: 'Bathrooms', value: '5' },
      { label: 'Living Areas', value: '1' },
      { label: 'Kitchen', value: '1' },
    ],
    rooms: [
      { name: 'M. Bedroom 2', size: `19'5" x 12'0"` },
      { name: 'M. Bedroom 3', size: `15'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 18'0"` },
      { name: 'G. Bedroom 1', size: `12'0" x 14'0"` },
      { name: 'Drawing Room', size: `12'0" x 20'0"` },
      { name: 'Dining', size: `19'7" x 12'0"` },
      { name: 'Living', size: `15'0" x 13'0"` },
      { name: 'Kitchen', size: `15'0" x 11'5"` },
      { name: 'Puja', size: `6'0" x 6'0"` },
      { name: 'Private Foyer', size: `11'0" x 15'0"` },
      { name: 'Servant Room', size: `10'0" x 7'2"` },
      { name: 'Verandah', size: `27'6" x 9'0"` },
    ],
  },
  {
    id: '4bhk-even-type2',
    title: '4 BHK - Type B',
    subtitle: 'Block B - Units 202, 203, 402, 403...2002, 2003',
    badge: 'EVEN FLOORS',
    badgeColor: 'blue',
    totalArea: '~2,900 sq.ft.',
    carpetArea: '~2,175 sq.ft.',
    features: ['Central Unit', 'Private Foyer', 'Efficient Layout'],
    technicalPlan: '/assets/floorPlan/4BHK_BLOCK_B_202,203,402,403,602-2002,603-2003_2nd_4th_6th_8th_upuintill20thfloor..png',
    isometricView: '/assets/floorPlan/ISOMETRIC_IMAGES/isometric_4BHK_BLOCK_B_202,203,402,403,602-2002,603-2003_2nd_4th_6th_8th_upuintill20thfloor..webp',
    highlights: [
      { label: 'Bedrooms', value: '4' },
      { label: 'Bathrooms', value: '5' },
      { label: 'Living Areas', value: '1' },
      { label: 'Kitchen', value: '1' },
    ],
    rooms: [
      { name: 'M. Bedroom 2', size: `19'5" x 12'0"` },
      { name: 'M. Bedroom 3', size: `15'0" x 12'0"` },
      { name: 'Bedroom 3', size: `12'0" x 18'0"` },
      { name: 'G. Bedroom 1', size: `12'0" x 14'0"` },
      { name: 'Drawing Room', size: `12'0" x 20'0"` },
      { name: 'Dining', size: `19'7" x 12'0"` },
      { name: 'Living', size: `15'0" x 13'0"` },
      { name: 'Kitchen', size: `15'0" x 11'5"` },
      { name: 'Puja', size: `6'0" x 6'0"` },
      { name: 'Private Foyer', size: `11'0" x 15'0"` },
      { name: 'Servant Room', size: `10'0" x 7'2"` },
      { name: 'Verandah', size: `17'6" x 9'6"` },
    ],
  },
];

// Floor Plan Card Component
function FloorPlanCard({ plan, isPremium = false }: { plan: typeof floorPlans5BHK[0]; isPremium?: boolean }) {
  const badgeColors = {
    amber: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    green: 'bg-green-500/20 text-green-400 border-green-500/30',
  };

  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden hover:border-white/20 transition-colors">
      {/* Header */}
      <div className="p-6 border-b border-white/10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-2xl font-bold text-white">{plan.title}</h3>
              <span className={`px-3 py-1 rounded-full text-xs font-medium border ${badgeColors[plan.badgeColor as keyof typeof badgeColors]}`}>
                {plan.badge}
              </span>
            </div>
            <p className="text-white/60 text-sm">{plan.subtitle}</p>
            <div className="flex items-center gap-4 mt-2 text-sm">
              <span className="text-white/80">
                <span className="text-white/50">Super Built-up:</span> {plan.totalArea}
              </span>
              <span className="text-white/80">
                <span className="text-white/50">Carpet:</span> {plan.carpetArea}
              </span>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="flex flex-wrap gap-4">
            {plan.highlights.map((item) => (
              <div key={item.label} className="text-center min-w-[60px]">
                <p className="text-2xl font-bold text-white">{item.value}</p>
                <p className="text-xs text-white/60">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Features */}
        <div className="flex flex-wrap gap-2 mt-4">
          {plan.features.map((feature) => (
            <span
              key={feature}
              className="bg-white/5 text-white/70 px-3 py-1 rounded-full text-xs border border-white/10"
            >
              {feature}
            </span>
          ))}
        </div>
      </div>

      {/* Isometric View - Main Feature */}
      <div className="p-4 bg-gradient-to-b from-neutral-900/50 to-neutral-950/50">
        <ImageLightbox
          src={plan.isometricView}
          alt={`${plan.title} Isometric View - Magnate Regalia`}
          className="w-full h-72 md:h-96"
          preload={isPremium}
        />
      </div>

      {/* Room Dimensions - Collapsible */}
      <details className="group border-t border-white/10">
        <summary className="p-4 py-5 cursor-pointer hover:bg-white/5 transition-colors flex items-center justify-between min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-inset">
          <span className="text-white/70 text-sm font-medium">View Room Dimensions</span>
          <svg
            className="w-5 h-5 text-white/50 transition-transform group-open:rotate-180"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {plan.rooms.map((room) => (
              <div
                key={room.name}
                className="bg-white/5 rounded-lg p-3 hover:bg-white/10 transition-colors"
              >
                <p className="text-white font-medium text-sm">{room.name}</p>
                <p className="text-white/60 text-xs mt-1">{room.size}</p>
              </div>
            ))}
          </div>
        </div>
      </details>
    </div>
  );
}

export default function LayoutsPage() {
  return (
    <main className="min-h-screen relative overflow-hidden">
      {/* Liquid Ether Background */}
      <div className="fixed inset-0 z-0">
        <LazyLiquidEther
          colors={['#D4A574', '#8B6914', '#C9A227']}
          mouseForce={20}
          cursorSize={100}
          resolution={0.5}
          isViscous={false}
          viscous={30}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          autoResumeDelay={2000}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {/* Content wrapper - above background */}
      <div className="relative z-10 pt-[108px] md:pt-32 px-4 pb-20">
        <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Floor Plans & Layouts
          </h1>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Explore our thoughtfully designed 4BHK and 5BHK luxury apartments with stunning 3D isometric views.
            Each unit is crafted to maximize space, light, and comfort.
          </p>
        </div>

        {/* Quick Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <a
            href="#5bhk"
            className="bg-amber-500/20 hover:bg-amber-500/30 text-amber-400 px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium transition-colors border border-amber-500/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
          >
            5 BHK Layouts
          </a>
          <a
            href="#4bhk"
            className="bg-blue-500/20 hover:bg-blue-500/30 text-blue-400 px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium transition-colors border border-blue-500/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
          >
            4 BHK Layouts
          </a>
          <a
            href="#building"
            className="bg-white/10 hover:bg-white/20 text-white/80 px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium transition-colors border border-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            Building Plans
          </a>
        </div>

        {/* Key Features Banner */}
        <div className="bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-blue-500/10 rounded-2xl border border-white/10 p-6 mb-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="text-3xl font-bold text-white">G+21</p>
              <p className="text-white/60 text-sm">Floors</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-white">2</p>
              <p className="text-white/60 text-sm">Towers (A & B)</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-white">4</p>
              <p className="text-white/60 text-sm">Units per Floor</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-white">84</p>
              <p className="text-white/60 text-sm">Total Units</p>
            </div>
          </div>
        </div>

        {/* 5BHK Section */}
        <section id="5bhk" className="mb-16 scroll-mt-32">
          <div className="flex items-center gap-4 mb-8">
            <h2 className="text-3xl font-bold text-white">5 BHK Apartments</h2>
            <span className="bg-amber-500/20 text-amber-400 px-4 py-1 rounded-full text-sm font-medium border border-amber-500/30">
              Block A
            </span>
          </div>
          <p className="text-white/60 mb-8 max-w-2xl">
            Expansive 5-bedroom residences in Block A, featuring dual living areas, wet + dry kitchen setup,
            and generous verandahs. Perfect for large families seeking uncompromised luxury.
          </p>

          <div className="grid gap-8">
            {floorPlans5BHK.map((plan, index) => (
              <FloorPlanCard key={plan.id} plan={plan} isPremium={index === 0} />
            ))}
          </div>
        </section>

        {/* 4BHK Section */}
        <section id="4bhk" className="mb-16 scroll-mt-32">
          <div className="flex items-center gap-4 mb-8">
            <h2 className="text-3xl font-bold text-white">4 BHK Apartments</h2>
            <span className="bg-blue-500/20 text-blue-400 px-4 py-1 rounded-full text-sm font-medium border border-blue-500/30">
              Block B
            </span>
          </div>
          <p className="text-white/60 mb-8 max-w-2xl">
            Elegantly designed 4-bedroom residences in Block B, featuring private foyers,
            spacious living areas, and well-proportioned bedrooms. Ideal for modern families.
          </p>

          <div className="grid gap-8">
            {floorPlans4BHK.map((plan, index) => (
              <FloorPlanCard key={plan.id} plan={plan} isPremium={index === 0} />
            ))}
          </div>
        </section>

        {/* Building Floor Plans */}
        <section id="building" className="mb-16 scroll-mt-32">
          <h2 className="text-3xl font-bold text-white mb-8">Building Floor Plans</h2>
          <p className="text-white/60 mb-8 max-w-2xl">
            Overview of the building layout showing Block A (5BHK) and Block B (4BHK) configurations
            along with common amenities and facilities.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Ground Floor */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
              <div className="p-4 border-b border-white/10">
                <h3 className="text-xl font-semibold text-white">Ground Floor</h3>
                <p className="text-white/60 text-sm mt-1">Amenities & Common Areas</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {['Swimming Pool', 'Theatre', 'Banquet Hall', 'Gym', 'Kids Play Area'].map((amenity) => (
                    <span key={amenity} className="bg-white/10 text-white/70 px-2 py-1 rounded text-xs">
                      {amenity}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4 bg-neutral-900">
                <ImageLightbox
                  src="/assets/floorPlan/building-ground-floor.png"
                  alt="Ground Floor Plan - Magnate Regalia"
                  className="w-full h-64 md:h-80"
                />
              </div>
            </div>

            {/* First Floor */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
              <div className="p-4 border-b border-white/10">
                <h3 className="text-xl font-semibold text-white">First Floor</h3>
                <p className="text-white/60 text-sm mt-1">Premium Units with Private Terraces</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {['5BHK x 2 (Block A)', '4BHK x 2 (Block B)', 'Club House', 'Cafe Area'].map((item) => (
                    <span key={item} className="bg-white/10 text-white/70 px-2 py-1 rounded text-xs">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4 bg-neutral-900">
                <ImageLightbox
                  src="/assets/floorPlan/building-first-floor.png"
                  alt="First Floor Plan - Magnate Regalia"
                  className="w-full h-64 md:h-80"
                />
              </div>
            </div>

            {/* Typical Even Floor */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
              <div className="p-4 border-b border-white/10">
                <h3 className="text-xl font-semibold text-white">Typical Floor (Even)</h3>
                <p className="text-white/60 text-sm mt-1">2nd, 4th, 6th, 8th...20th Floors</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {['5BHK x 2 (Block A)', '4BHK x 4 (Block B)'].map((item) => (
                    <span key={item} className="bg-white/10 text-white/70 px-2 py-1 rounded text-xs">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4 bg-neutral-900">
                <ImageLightbox
                  src="/assets/floorPlan/Typical_Even_floor_2nd_4th_6th....png"
                  alt="Typical Even Floor Plan - Magnate Regalia"
                  className="w-full h-64 md:h-80"
                />
              </div>
            </div>

            {/* Typical Odd Floor */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
              <div className="p-4 border-b border-white/10">
                <h3 className="text-xl font-semibold text-white">Typical Floor (Odd)</h3>
                <p className="text-white/60 text-sm mt-1">3rd, 5th, 7th, 9th...21st Floors</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {['5BHK x 2 (Block A)', '4BHK x 4 (Block B)'].map((item) => (
                    <span key={item} className="bg-white/10 text-white/70 px-2 py-1 rounded text-xs">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4 bg-neutral-900">
                <ImageLightbox
                  src="/assets/floorPlan/typical_odd_floor_3rd-5th-7th-etc..png"
                  alt="Typical Odd Floor Plan - Magnate Regalia"
                  className="w-full h-64 md:h-80"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Request Brochure CTA */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-amber-500/20 to-amber-600/20 rounded-2xl border border-amber-500/30 p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-3">
              Want Technical Floor Plans?
            </h3>
            <p className="text-white/70 mb-6 max-w-xl mx-auto">
              Request our comprehensive brochure with detailed dimensions, specifications,
              material finishes, and virtual tour links.
            </p>
            <a
              href="/contact?message=I%20would%20like%20to%20request%20the%20Magnate%20Regalia%20brochure%20with%20detailed%20floor%20plans.%20Please%20send%20it%20to%20my%20email%20or%20WhatsApp."
              className="inline-block bg-amber-500 hover:bg-amber-600 text-black font-semibold px-8 py-3 rounded-lg transition-colors"
            >
              Request Brochure
            </a>
          </div>
        </section>

        {/* Specifications Highlight */}
        <section className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-8">
          <h3 className="text-2xl font-bold text-white mb-6">Premium Specifications</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Structure
              </h4>
              <p className="text-white/60 text-sm">
                Quality controlled, earthquake resistant RCC frame structure
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Flooring
              </h4>
              <p className="text-white/60 text-sm">
                Premium quality vitrified tiles in drawing, dining, living & kitchen areas
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Kitchen
              </h4>
              <p className="text-white/60 text-sm">
                Granite platform with SS sink, dado tiles up to lintel level
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Doors & Windows
              </h4>
              <p className="text-white/60 text-sm">
                Wooden frame doors with safety locks, fully glazed powder-coated aluminum windows
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Electrical
              </h4>
              <p className="text-white/60 text-sm">
                3-phase concealed copper cabling with premium modular switches
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Common Areas
              </h4>
              <p className="text-white/60 text-sm">
                High-speed elevators, stone-finished staircase
              </p>
            </div>
          </div>
        </section>
        </div>
      </div>
    </main>
  );
}
